import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today",
  "description": "",
  "published": "2011-07-18T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today/swizec/1956"],
  "categories": "Plaintext, Programming, Security, Superuser, Uncategorized, Whiteboard",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The first thing I learned is that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Whiteboard",
        "title": "Whiteboard"
      }}>{`dry erase`}</a>{` markers don't work under the shower.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-DD-Tank1.jpg",
        "alt": "Sherman DD (Duplex Drive) amphibious tank with...",
        "title": "Sherman DD (Duplex Drive) amphibious tank with..."
      }}></img></p>
    <p>{`It gets too steamy and awesome ... I'm going to have to find a better solution for efficient shower brainstorming. Some sort of water resistant marker that works on tiles but can be erased without too big a hassle.`}</p>
    <p><em parentName="p">{`tl;dr --> no matter what it seems like, the first price a client suggests is never fair.`}</em></p>
    <p>{`Another thing I learned is never again to take a job making a "simple extension to our existing website, it's pretty simple and easy".`}</p>
    <p>{`At least, I will never again take such a job without raising their suggested price at least 50%.`}</p>
    <p>{`Admittedly, that's my bad, they gave me an offer and I simply took it without thinking too much about it. Seemed like an easy enough job, the price seemed fair, something that would easily accomodate my normal hourly rate in the time I thought was needed to complete the job. And I like money, it lets me buy food.`}</p>
    {
      /*more*/
    }
    <p>{`I still think I scheduled enough time.`}</p>
    <p>{`But I forgot to account for the annoyance of working on a legacy system I don't have the first clue about. What's worse, the website seems to have originally been developed in the time when everyone and their grandmother was making a custom CMS.`}</p>
    <p>{`Yeah, you can't even begin to imagine.`}</p>
    <p>{`Let me just share a couple cookies from the beautiful source:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`if ($admin_super == 1) $superuser = 1;

if (($superuser == 1)) {    ...
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`// added by /../, 16/01/2006, modified 20/12/2007
`}</code></pre>
    <p>{`Yes. That bad.`}</p>
    <p>{`To make it more fun, the admin interface is made so every form can only handle a single `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Table_%28database%29",
        "title": "Table (database)"
      }}>{`database table`}</a>{`.`}</p>
    <p>{`Naturally my extension requires a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Data_model",
        "title": "Data model"
      }}>{`data model`}</a>{` encompassing many interconnected tables.`}</p>
    <p>{`But ok, I get it, five years ago my code wasn't exactly perfect either. It still isn't. Maybe I could have done a little better, maybe I would have done worse.`}</p>
    <p>{`The thing that really gets me though is having to chloroform my coding standards, drag them to a dark alleyway and rape them, listening to their muffled sobs. I cry a little every time! But a choice had to be made, either rewrite this client's whole website, or rape my standards and complete the project within budget, then learn a good lesson and never do this again for cheap.`}</p>
    <p>{`Oh and I've found at least two possible/obvious security holes so far.`}</p>
    <p>{`Not to mention that user passwords are stored in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Plaintext",
        "title": "Plaintext"
      }}>{`plaintext`}</a>{` in the database and the admin's password is stored in a config file in plaintext ... oh yeah. Gotta love that!`}</p>
    <p>{`Good lesson. Taking it to heart ... no matter what it seems like, the first price a client gives is never fair.`}</p>
    <p>{`PS: the main developer guy specifically warned me that this isn't opensource and I should treat the source with the respect and dignity it deserves`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://viralsolani.wordpress.com/2011/07/17/203/"
        }}>{`MySQL Injection Attacks`}</a>{` (viralsolani.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.livingrichwithcoupons.com/2011/04/new-expo-washable-markers-house-party.html"
        }}>{`New Expo Washable Markers House Party`}</a>{` (livingrichwithcoupons.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.escapistmagazine.com/articles/view/editorials/letters/8906-Letters-to-the-Editor-Making-Morality-Matter"
        }}>{`Letters to the Editor: Making Morality Matter`}</a>{` (escapistmagazine.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=44acab09-6d5f-4475-b384-981f6cf8ee28",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      